import request from '../utils/request'

const baseURL = 'https://wechatapi.hndnews.com'

// 频道列表
export function wxAuthPageSign(params) {
    return request({
        baseURL,
        url: '/wx/authPageSign',
        method: 'get',
        params
    })
}



